import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { compose } from "react-apollo";

import Loader from "../../components/Loader/Loader";
import Avatar from "../../components/Avatar/Avatar";
import DropZone from "../../components/Dashboard/DropZone";

import { doRemoveProfilePicture } from "../../actions/manageUserProfilePicture";
import messages from "../../locale/messages";

class ProfileUpload extends React.Component {

    render() {
        const { picture, userId, profilePhotoLoader, data, maxUploadSize, doRemoveProfilePicture } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className="editProfileBox">
                <Loader
                    show={profilePhotoLoader}
                    type={"page"}
                >
                    <div className="editProfileAvatarContainer">
                        <Avatar
                            source={picture}
                            userId={userId}
                        />
                    </div>

                </Loader>
                <div className={picture ? "avatarEditButton" : 'marginBottom20'}>
                    <DropZone
                        data={data}
                        maxUploadSize={maxUploadSize}
                        defaultMessage={!picture ? formatMessage(messages.editProfilePhoto) : <></>}
                        isEditIcon={picture ? true : false}
                    />
                </div>


                {
                    picture && 
                        <a onClick={() => doRemoveProfilePicture(picture, userId)} className="removeAvatarText">
                            <FormattedMessage {...messages.removePhotos} />
                        </a>
                  
                }
            </div>
        )
    }
}

const mapState = (state) => ({
    profilePhotoLoader: state?.loader?.profilePhotoLoader
})
const mapDispatch = {
    doRemoveProfilePicture
}

export default compose(injectIntl, connect(mapState, mapDispatch))(ProfileUpload);